import { IBioBadgeItem } from '../typings/IBioBadges';

export const sortBadgesByActiveProductsCount = (badges: IBioBadgeItem[], isInCourierArea: boolean): IBioBadgeItem[] => {
  if (!badges?.length) {
    return [];
  }
  return [...badges].sort((a: IBioBadgeItem, b: IBioBadgeItem) => {
    if (isInCourierArea) {
      return (b?.activeProductsCount || 0) - (a?.activeProductsCount || 0);
    }
    return (b?.activeProductsWithBoxDeliveryAllowedCount || 0) - (a?.activeProductsWithBoxDeliveryAllowedCount || 0);
  });
};
